import React, { createContext, useContext, useState } from "react";

const dict = {
  en: {
    dashboard: "Dashboard",
    jobs: "Jobs",
    adas_analysis: "ADAS Analysis",
    oem_research: "OEM Research",
    calibration_center: "Calibration Center",
    billing: "Billing",
    insurance_claims: "Insurance Claims",
    body_shop_portal: "Body Shop Portal",
    reports: "Reports",
    financial: "Financial",
    ai_assistant: "AI Assistant",
    crm: "CRM",
    scheduling: "Scheduling",
    settings: "Settings",
    logout: "Sign out",
    login: "Sign in",
    welcome_back: "Welcome back",
    sign_in_to_continue: "Sign in to continue to TrueLine",
    email: "Email",
    password: "Password",
    revenue_total: "Total Revenue",
    revenue_pending: "Pending Revenue",
    profit: "Estimated Profit",
    active_jobs: "Active Jobs",
    new_job: "New Job",
    search: "Search...",
    save: "Save",
    cancel: "Cancel",
    create: "Create",
    no_jobs: "No jobs yet",
    upload_estimate: "Upload Estimate",
    parse_ocr: "Run OCR",
  },
  pt: {
    dashboard: "Painel",
    jobs: "Ordens",
    adas_analysis: "Análise ADAS",
    oem_research: "Pesquisa OEM",
    calibration_center: "Centro de Calibração",
    billing: "Faturamento",
    insurance_claims: "Sinistros Seguradora",
    body_shop_portal: "Portal Funilaria",
    reports: "Relatórios",
    financial: "Financeiro",
    ai_assistant: "Assistente IA",
    crm: "CRM",
    scheduling: "Agenda",
    settings: "Configurações",
    logout: "Sair",
    login: "Entrar",
    welcome_back: "Bem-vindo de volta",
    sign_in_to_continue: "Entre para acessar a TrueLine",
    email: "E-mail",
    password: "Senha",
    revenue_total: "Receita Total",
    revenue_pending: "Receita Pendente",
    profit: "Lucro Estimado",
    active_jobs: "Ordens Ativas",
    new_job: "Nova Ordem",
    search: "Buscar...",
    save: "Salvar",
    cancel: "Cancelar",
    create: "Criar",
    no_jobs: "Sem ordens ainda",
    upload_estimate: "Upload Estimativa",
    parse_ocr: "Executar OCR",
  },
};

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("trueline_lang") || "en");
  const t = (key) => dict[lang][key] || dict.en[key] || key;
  const switchLang = (l) => {
    setLang(l);
    localStorage.setItem("trueline_lang", l);
  };
  return (
    <LangContext.Provider value={{ lang, t, switchLang }}>{children}</LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
